import { makeStyles } from "@material-ui/core";

const useRbSwipeViewItemStyles = makeStyles({
  root: {
    position: "relative",
    width: "100%",
    border: "10px solid red",
  },
});

export default useRbSwipeViewItemStyles;
